'use client';

// Рендер ленты сообщений генератора (user / «думаю…» / вопрос / схема).
// Только вью: состояние и обработчики — в Generator.tsx.
import styles from './generator.module.css';
import { Needs, Schema, Who } from './schema-view';
import { type GeneratorDict, type SchemaNode } from './schema';

export interface UserMsg {
  id: number;
  role: 'user';
  text: string;
}
export interface TypingMsg {
  id: number;
  role: 'typing';
}
export interface AskMsg {
  id: number;
  role: 'ask';
  text: string;
  options?: string[]; // варианты-кнопки (необязательно; можно ответить и текстом)
}
export interface BotMsg {
  id: number;
  role: 'bot';
  isUpdate: boolean;
  nodes: SchemaNode[];
  showActions: boolean;
}
export type Msg = UserMsg | TypingMsg | AskMsg | BotMsg;

interface Props {
  messages: Msg[];
  dict: GeneratorDict;
  markSrc: string;
  acceptHref: string;
  /** Клик по кнопке-варианту вопроса → отправить как ответ. */
  onOption: (text: string) => void;
  /** Последний бот-ответ — для позиционирования скролла в Generator. */
  lastBotRef: React.MutableRefObject<HTMLDivElement | null>;
}

export function ChatMessages({ messages, dict, markSrc, acceptHref, onOption, lastBotRef }: Props) {
  return (
    <>
      {messages.map((m) => {
        if (m.role === 'user') {
          return (
            <div key={m.id} className={`${styles.msg} ${styles.user}`}>
              {m.text}
            </div>
          );
        }
        if (m.role === 'typing') {
          return (
            <div key={m.id} className={`${styles.msg} ${styles.bot}`}>
              <Who name={dict.botName} mark={markSrc} />
              <div className={styles.typing} aria-label={dict.thinking}>
                <i />
                <i />
                <i />
              </div>
            </div>
          );
        }
        if (m.role === 'ask') {
          return (
            <div key={m.id} className={`${styles.msg} ${styles.bot}`}>
              <Who name={dict.botName} mark={markSrc} />
              <div>
                {m.text}
                {m.options && m.options.length > 0 && (
                  <>
                    <div className={styles.askOptions}>
                      {m.options.map((opt) => (
                        <button
                          key={opt}
                          type="button"
                          className={styles.askChip}
                          onClick={() => onOption(opt)}
                        >
                          {opt}
                        </button>
                      ))}
                    </div>
                    <div className={styles.askHint}>{dict.askHint}</div>
                  </>
                )}
              </div>
            </div>
          );
        }
        return (
          <div
            key={m.id}
            ref={(el) => {
              lastBotRef.current = el;
            }}
            className={`${styles.msg} ${styles.bot}`}
          >
            <Who name={dict.botName} mark={markSrc} />
            <div>
              {m.isUpdate ? (
                dict.updateReply
              ) : (
                <>
                  {dict.firstReply}
                  <span className={styles.dim}>{dict.firstReplyDim}</span>
                </>
              )}
              <Schema dict={dict} nodes={m.nodes} />
              {m.showActions && (
                <>
                  <Needs dict={dict} nodes={m.nodes} />
                  <div className={styles.sell}>
                    <div className={styles.sellH}>{dict.sellTitle}</div>
                    <div className={styles.sellP}>{dict.sellText}</div>
                    <a href={acceptHref} className={styles.cta}>
                      {dict.accept}
                    </a>
                  </div>
                </>
              )}
            </div>
          </div>
        );
      })}
    </>
  );
}
